<template>
  <v-btn
    color="primary"
    icon
    @click="editListAction(row)"
  >
    <v-icon>mdi-eye</v-icon>
  </v-btn>
</template>

<script>

export default {
  name: 'TemplateViewColumn',
  props: {
    row: {
      type: Object,
      default() {
        return {
          id: '',
        };
      },
    },
  },
  inject: {
    editListAction: {
      default: () => {},
    },
  },
};
</script>
